import React from "react";

class GlobalHeader extends React.Component {
  render() {
    // const updateClickstream = this.props.updateClickstream;
    return (
      <div className="global_header">
        <span className="ui-logo">IMPRINT</span>
        <a
          href="http://imprintcontent.com"
          className="ui-close"
          // onClick={() => {
          //   updateClickstream('http://ubs.com', 'Close Icon');
          // }}
        >
          Close
        </a>
      </div>
    );
  }
}

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader.js